import React from 'react'
import PropTypes from 'prop-types'
import { Container, Image } from 'components/qstrap'
import CardContainer from 'components/authentication/CardContainer'
import Footer from 'components/authentication/Footer'
import StepBar from 'components/authentication/StepBar'

const ExternalLayout = props => (
  <div id={props.id}>
    <Container className="text-center">
      <Image src="/assets/img/logo/quipper-w.svg" className="m-y-lg" />
      {props.stepBar && <StepBar />}
      <CardContainer>{props.children}</CardContainer>
      <Footer />
    </Container>
  </div>
)

ExternalLayout.propTypes = {
  id: PropTypes.string,
  stepBar: PropTypes.bool,
}

export default ExternalLayout
